import { gsap } from "gsap";

class IonCollapsible extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector("button");
        this.panel = this.querySelector(".panel");

        gsap.set(this.panel, { height: 0, autoAlpha: 0 });

        this.button.addEventListener("click", this.onClickButton.bind(this));
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === "false" && newValue === "true") {
            this.open();
        } else if (oldValue === "true" && newValue === "false") {
            this.close();
        }
    }

    static get observedAttributes() {
        return ["open"];
    }

    get isOpen() {
        return this.getAttribute("open") === "true";
    }

    onClickButton() {
        this.setAttribute("open", !this.isOpen);
    }

    open() {
        gsap.to(this.panel, {
            height: "auto",
            autoAlpha: 1,
            duration: 0.3,
        });
    }

    close() {
        gsap.to(this.panel, {
            height: 0,
            autoAlpha: 0,
            duration: 0.3,
        });
    }
}

// const collapsibleButtons = document.querySelectorAll("ion-collapsible button");

// collapsibleButtons.forEach((button) => {
//     button.addEventListener("click", () => {
//         console.log(document.querySelectorAll("ion-collapsible[open=true]"));
//     });
// });

customElements.define("ion-collapsible", IonCollapsible);
